"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameModule = void 0;
var GameModule;
(function (GameModule) {
    GameModule["Override"] = "invalid";
    GameModule["Base"] = "Base";
    GameModule["CorpEra"] = "Corp Era";
    GameModule["Promo"] = "Promo";
    GameModule["Venus"] = "Venus";
    GameModule["Colonies"] = "Colonies";
    GameModule["Prelude"] = "Prelude";
    GameModule["Turmoil"] = "Turmoil";
    GameModule["PreludeTwo"] = "Prelude 2";
    GameModule["Community"] = "Community";
    GameModule["Ares"] = "Ares";
    GameModule["Moon"] = "Moon";
    GameModule["Leader"] = "Leader";
    GameModule["Automa"] = "Automa";
})(GameModule = exports.GameModule || (exports.GameModule = {}));
//# sourceMappingURL=GameModule.js.map